import Title from '@/components/ui/Title'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

const EldritchGame = () => {
  return (
    <div className="py-4 px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="Eldritch Game" />
      <p className="text-3xl leading-12 md:px-16">
        All assets, animations and integration into Unity Engine for this
        project were done by myself. The goal here was to create a design for a
        video game, produce the assets, implement these into the game engine,
        and then add VFX and post effects. My game concept centered on the
        player character being transported into a strange and hostile landscape,
        with cosmic entities watching their every move. The player will harness
        the natural and unnatural environment around them, distilling spirits
        into essences, scrying bones for fortune and creating ritual offerings
        to different eldritch deities. Cosmic horror is a big inspiration for
        this concept, and the further the player goes to get the interest of
        their deity, the more likely that they will draw unwanted attention from
        other beings…
      </p>
      <p className="text-3xl leading-12 md:px-16">
        Coming up with a consistent palette and artstyle was crucial for this
        project, and inspiration was drawn from a lot of vintage art and
        Victorian fashion. From a game design perspective it was vital to
        consider the layout and how different assets drew player attention.
        Creating an appropriate and clear UI, as well as ensuring that the
        interactable elements were clearly signposted against the background
        were important considerations.
      </p>
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Eldritch Valley"
          src="https://www.youtube.com/embed/W7xTT57Ul1A"
        />
      </div>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry>
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/idle.gif"
            alt="Idle Animation"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/asset_sheet.webp"
            alt="Asset Sheet"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/dial.webp"
            alt="Dial User Interface"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/tileset.webp"
            alt="Tileset"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/map.webp"
            alt="Map"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/spider.gif"
            alt="Animated Spider"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/ui4.webp"
            alt="UI Elements 1"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/ui1.webp"
            alt="UI Elements 2"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/ui2.webp"
            alt="UI Elements 3"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/ui3.webp"
            alt="UI Elements 4"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/particles1.webp"
            alt="Particle Examples 1"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/particles2.webp"
            alt="Particle Examples 2"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/EldritchGame/lighting.webp"
            alt="Lighting Example"
          />
        </Masonry>
      </ResponsiveMasonry>
    </div>
  )
}

export default EldritchGame
